<dx-popup class="popup"
          [width]="isPhoneOrTablet ? '90vw' : 800"
          [height]="isPhoneOrTablet ? '80vh' : '80vh'"
          [showTitle]="true"
          [dragEnabled]="true"
          [closeOnOutsideClick]="false"
          [showCloseButton]="false" [(visible)]="popupVisible" (onShown)="onShown()">
    <dxi-toolbar-item location="before">
        <h4 style="margin: 5px 0">Missing Information</h4>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="before">
        <dx-load-indicator
            height="20"
            width="20"
            [(visible)]="isLoading"
            style="margin-left: 8px; margin-top: 4px;"
        ></dx-load-indicator>
    </dxi-toolbar-item>
  <dxi-toolbar-item location="after" *ngIf="isAudioRecordingEnabled">
    <app-mic-to-json-button #micButton [area]="'missing-info'" [fileName]="order.orderCode + '-missing-info-'"
                            [questions]="autocompleteService.Questions"
                            (jsonAvailable)="autocompleteService.onJsonChange($event, order.patient?.id ?? -1)"
                            [json]="autocompleteService.MissingInfoJson"></app-mic-to-json-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Save" (click)="submit()" style="margin-left: 8px;"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%;">
        <dx-scroll-view [showScrollbar]="'onScroll'">
            <form [formGroup]="missingInfoForm" style="height: 100%;">
                <div fxLayout="column" fxFlex="100%">
                    <div id="form" fxLayout="row" fxLayoutAlign="center">
                        <div class="ocl-dialog-content" fxLayout="column" fxLayoutAlign="space-between start">
                            <div fxLayout="row" fxLayout.xs="column" style="width: 60%; padding: 5px 16px"
                                 [ngStyle.xs]="{width: '100%'}" fxLayoutAlign="space-between"
                                 *ngIf="order !== undefined && order !== null">
                                <div fxLayout="column">
                                    <address>
                                        <strong>Patient: </strong>
                                        {{ order.patient?.firstName + ', ' + order.patient?.lastName}} <br/>
                                        <strong>BirthDate: </strong>
                                        {{ PatientDate }}<br/>
                                        <strong>Client: </strong>
                                        {{ order.patient?.client?.name }}
                                    </address>
                                </div>
                                <div fxLayout="column">
                                    <address>
                                        <strong>Unit: </strong>
                                        {{ order.patient?.unit?.name }} <br/>
                                        <strong>Room: </strong>
                                        {{ order.patient?.room?.name }}<br/>
                                    </address>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayout.xs="column" style="width: 100%; padding: 5px 16px"
                                 fxLayoutAlign="space-between">
                                <div fxLayout="column" fxFlex="30%">
                                    <div>
                                        <div class="dx-field-label">BirthDate <span
                                            class="ocl-required-indicator">*</span>
                                        </div>
                                        <div class="dx-field-value">
                                            <dx-date-box formControlName="birthDate" type="date" [max]="today"
                                                         (onValueChanged)="birthDateChange($event)">
                                                <dx-validator validationGroup="missingInfo">
                                                    <dxi-validation-rule type="required"
                                                                         message="Date of birth is required"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-date-box>
                                        </div>
                                    </div>
                                </div>
                                <div fxLayout="column" fxFlex="30%">
                                    <div>
                                        <div class="dx-field-label">Gender <span class="ocl-required-indicator">*</span>
                                        </div>
                                        <div class="dx-field-value">
                                            <dx-select-box [dataSource]="gender" formControlName="gender"
                                                           (onValueChanged)="genderChange($event)">
                                                <dx-validator validationGroup="missingInfo">
                                                    <dxi-validation-rule type="required"
                                                                         message="Gender is required"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </div>
                                <div fxLayout="column" fxFlex="30%">
                                    <div>
                                        <app-physician-selector
                                            [label]="'Ordering Physician'"
                                            [buttonMode]="false"
                                            [control]="missingInfoForm.get('orderingPhysician')"
                                            [required]="true"
                                            [validationGroup]="'missingInfo'"
                                        ></app-physician-selector>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center"
                                 style="width: 100%; height: auto; padding: 5px 16px"
                                 [ngStyle.xs]="{'padding-top': '16px'}">
                                <dx-tab-panel
                                    [dataSource]="[
                                    { id: 1, title: 'Insurance Information', tabTemplate: 'headerBillingInformation' ,template: 'billingInformationTabTemplate'},
                                    { id: 2, title: 'Diagnoses', tabTemplate: 'headerDiagnoses', template: 'diagnosesTabTemplate' },
                                    { id: 3, title: 'Responsible Party', template: 'responsiblePartiesTabTemplate' }
                                ]"
                                    [height]="isPhone ? '600px' : '350px'"
                                    [selectedIndex]="0"
                                    [loop]="false"
                                    style="max-height: 655px; width: 100% !important;"
                                    [animationEnabled]="true"
                                    [swipeEnabled]="true">
                                    <div *dxTemplate="let content of 'headerBillingInformation'">
                                        <div fxLayout="row">
                                            <span style="margin-right: 3px">{{content.title}}</span>
                                            <i *ngIf="this.hasMissingBillingInformation" class="dx-icon-warning"
                                               style="font-size: 16px; color: #ff9d09" title="Missing Information"></i>
                                        </div>
                                    </div>
                                    <div *dxTemplate="let company of 'billingInformationTabTemplate'">
                                        <app-billing-information [patient]="order.patient"
                                                                 [deselectAll]="deselectAllBillingInfo"
                                                                 [patientBillingInformation]="missingInfoForm.get('insuranceInformation')?.value"
                                                                 (patientBillingInfoChanged)="billingInfoChanged($event)"></app-billing-information>
                                    </div>
                                    <div *dxTemplate="let content of 'headerDiagnoses'">
                                        <div fxLayout="row">
                                            <span style="margin-right: 3px">{{content.title}}</span>
                                            <i *ngIf="this.hasMissingDiagnosis" class="dx-icon-warning"
                                               style="font-size: 16px; color: #ff9d09" title="Missing Information"></i>
                                        </div>
                                    </div>
                                    <div *dxTemplate="let company of 'diagnosesTabTemplate'">
                                        <app-form-relation-glass
                                            id="diagnosesGlassControl"
                                            [textSelectorPlaceholder]="'Code'"
                                            [textSelectorExpr]="'code'"
                                            [label]="'Diagnoses'"
                                            [disabled]="isLoading"
                                            [dataSource]="diagnosisDataSource.value"
                                            [searchEnabled]="true"
                                            [searchService]="diagnosisDataSource.value"
                                            [keyExpr]="'id'"
                                            [columns]="['code', 'shortName']"
                                            [control]="convertToFormControl(missingInfoForm.get('diagnoses'))"
                                        ></app-form-relation-glass>
                                    </div>
                                    <div *dxTemplate="let company of 'responsiblePartiesTabTemplate'">
                                        <app-patient-responsible-parties
                                            [responsibleParties]="missingInfoForm.get('responsibleParties')?.value ?? []"
                                            (responsiblePartiesChanged)="responsiblePartiesChanged($event)">
                                        </app-patient-responsible-parties>
                                    </div>
                                </dx-tab-panel>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 240px; width: 100%"
                                 [ngStyle.xs]="{height: 'auto'}">
                                <app-comments-control #commentControl [label]="'Comments'"
                                                      [control]="missingInfoForm.get('comment')"
                                                      [ngStyle.xs]="{height: '360px'}"
                                                      [valueChange]="popupVisible">
                                </app-comments-control>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </dx-scroll-view>
    </div>
</dx-popup>
<dx-load-panel [visible]="(autocompleteService.IsLoading | async) ?? false" [message]="'Loading data...'"></dx-load-panel>
